<script setup lang="ts">
  import { InfoTooltip } from '../InfoTooltip';
  import { computed, useId } from 'vue';
  import { StatsList } from '../StatsList';
  import { TooltipPosition } from '../Tooltip';
  import {
    headerClass,
    rootClass,
    titleClass,
    titleGroupClass,
  } from './DataSummary.css';
  import type { DataSummaryProps } from './DataSummary.types';

  const props = defineProps<DataSummaryProps>();

  defineSlots<{
    default?: () => unknown;
    action?: () => unknown;
  }>();

  const uid = useId();
  const resolvedTestId = computed(
    () => props.testId ?? `ds-data-summary-${uid}`,
  );
  const titleId = computed(() => `ds-data-summary-title-${uid}`);
</script>

<template>
  <section
    :class="rootClass"
    :data-testid="resolvedTestId"
    :aria-labelledby="title ? titleId : undefined"
  >
    <div v-if="title || $slots.action" :class="headerClass">
      <div :class="titleGroupClass">
        <h2 v-if="title" :id="titleId" :class="titleClass">{{ title }}</h2>
        <InfoTooltip
          v-if="title && tooltipText"
          :description="tooltipText"
          :position="TooltipPosition.TOP"
        />
      </div>
      <slot name="action" />
    </div>
    <StatsList :test-id="`${resolvedTestId}-stats`"> <slot /> </StatsList>
  </section>
</template>
